import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';

export const supportedLanguages = ['fr', 'en', 'es'] as const;
export const authenticatedLanguageStorageKey = 'topchefAuthenticatedLanguage';
export const manualLanguageOverrideStorageKey = 'topchefManualLanguageOverride';

export const normalizeSupportedLanguage = (language?: string | null): string | undefined => {
  const normalizedLanguage = language?.toLowerCase().split(/[-_]/)[0];

  return normalizedLanguage && supportedLanguages.includes(normalizedLanguage as typeof supportedLanguages[number])
    ? normalizedLanguage
    : undefined;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'fr',
    supportedLngs: supportedLanguages,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: authenticatedLanguageStorageKey,
      caches: ['localStorage'],
      convertDetectedLanguage: (language) => normalizeSupportedLanguage(language) ?? 'fr',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
